import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomFieldComponent} from './custom-field.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {NgxMatTimepickerModule} from 'ngx-mat-timepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {NgxMaskDirective, provideEnvironmentNgxMask} from 'ngx-mask';
import {FieldComponent} from './field.component';
import {UploaderModule} from '@ee/common/uploader';
import { TippyDirective } from '@ngneat/helipopper';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMatTimepickerModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatIconModule,
    MatRadioModule,
    NgxMaskDirective,
    UploaderModule,
    TippyDirective
  ],
  declarations: [CustomFieldComponent, FieldComponent],
  exports: [CustomFieldComponent, FieldComponent],
  // ngx-mask's directive injects its config, so the provider has to be reachable from every host that
  // imports this module — not only the two app modules that already call it. Providing it here is
  // idempotent: the config is identical, and we deliberately keep the library default
  // `dropSpecialCharacters: true` so a custom field's mask stores the same shape as a built-in one's.
  providers: [provideEnvironmentNgxMask()]
})
export class CustomFieldModule {
  public static forRoot(environment: any): ModuleWithProviders<CustomFieldModule> {
    return {
      ngModule: CustomFieldModule,
      providers: [{ provide: 'environment', useValue: environment }]
    };
  }
}
